export enum ComparisonOperator {
  EQUALS = "$eq",
  NOT_EQUALS = "$ne",
  GREATER_THAN = "$gt",
  GREATER_OR_EQUAL_THAN = "$gte",
  LESS_THAN = "$lt",
  LESS_OR_EQUAL_THAN = "$lte",
  IN = "$in",
  NOT_IN = "$nin",
  ALL = "$all",
  REGEX = "$regex",
  TEXT = "$text",
}

export enum RegexOptions {
  CASE_INSENSITIVE = "i",
  MULTI_LINE = "m",
  DOT_ALL = "s",
  EXTENDED = "x",
}
